"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_image_file_resizer_1 = __importDefault(require("react-image-file-resizer"));
var ImageHelperClass = /** @class */ (function () {
    function ImageHelperClass() {
        this.resizeFile = function (file) {
            return new Promise(function (resolve) {
                react_image_file_resizer_1.default.imageFileResizer(file, 800, 800, 'JPEG', 60, 0, function (uri) {
                    resolve(uri);
                }, 'file');
            });
        };
        this.transformFileSize = function (file) {
            return ImageHelper.resizeFile(file);
        };
    }
    ImageHelperClass.prototype.getBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (error) { return reject(error); };
        });
    };
    return ImageHelperClass;
}());
// SINGLETON
var ImageHelper = new ImageHelperClass();
Object.freeze(ImageHelper);
exports.default = ImageHelper;
